import { Component, Input, OnInit } from "@angular/core";
import { StepStatus } from "src/app/interfaces";

@Component({
    selector: "step-status-icon",
    templateUrl: "./../step-icon.component.html",
    styleUrls: ["./../step-icon.component.scss"],
    standalone: false
})
export class StepStatusIconComponent implements OnInit {
  @Input() public status: StepStatus;

  @Input() public title = "";

  public statusImage: string;

  ngOnInit(): void {
    this.statusImage = null;

    switch (this.status) {
      case "Finished":
        this.statusImage = "close";
        break;
      case "Waiting":
        this.statusImage = "clock";
        break;
      case "InProgress":
        this.statusImage = "media-manager";
        break;
      case "Errored":
        this.statusImage = "error";
        break;
      case "Canceled":
        this.statusImage = "cancel";
        break;
    }
  }
}
